import { Typography } from '@mui/material';
import { action, observable, makeObservable } from 'mobx';
import {  observer } from 'mobx-react';
import React from 'react';
import Modal from '../../misc/Modal';
import { Processo } from '../../modelo';
import { IAutocomplete } from '../../modelo/Autocomplete';
import { ComplementoGEDTO, MovimentoGEDTO, TipoComplemento_DINAMICO, TipoComplemento_DOMINIO } from '../../modelo/MinutaMovimentos';
import MovimentoCNJStore from '../../store/MovimentoCNJStore';
import BotaoComplementoMovimento from './BotaoComplementoMovimento';
import ComplementoAutocomplete from './ComplementoAutocomplete';
import ComplementoTextField from './ComplementoTextField';

interface IPropsModalComplementoMovimento {
    movimento: MovimentoGEDTO;
    processo: Processo;
    emLote?: boolean;
    apenasBotoes?: boolean;
}


class ModalComplementoMovimento extends React.Component<IPropsModalComplementoMovimento> {
    complementos: ComplementoGEDTO[] = this.props.movimento.complementos?.slice() || [];


    constructor(props: IPropsModalComplementoMovimento) {
        super(props);

        makeObservable(this, {
            complementos: observable,
fecharModal: action,
            handleClickConfirmar: action,
            handleCallbackAutoComplete: action,
            setComplementos: action,
            setMovimentoComplementos: action,
});
    }


    get variaveis() {
        return this.props.movimento.variaveis;
    }

    fecharModal = () => {
        MovimentoCNJStore.modalComplementosOpen = false;
    };

    handleClickConfirmar = () => {
        this.setMovimentoComplementos();
        this.fecharModal();
    };

    handleCallbackAutoComplete = (ev, value: IAutocomplete<ComplementoGEDTO>) => {
        let nomeDominio = '';
        let complemento: ComplementoGEDTO;
        if (value) {
            nomeDominio = value?.valor.stringComplemento;
            complemento = ComplementoGEDTO.novo(value?.valor);
        } else {
            const id = ev.target.id.split('-');
            nomeDominio = id[id.length - 1];
        }

        this.setComplementos(nomeDominio, complemento, !value);
    };


    setComplementos = (nomeDominio: string, complemento: ComplementoGEDTO, excluir: boolean) => {
        const index = this.complementos.findIndex(comp => comp.stringComplemento === nomeDominio);

        if (excluir) {
            // Nada a excluir se o complemento ainda não estava na lista (index === -1).
            if (index >= 0) {
                this.complementos[index].valorSetado = '';
                this.complementos.splice(index, 1);
            }
        } else {
            const posicao = index >= 0 ? index : this.complementos.length;
            this.complementos.splice(posicao, 1, complemento);
        }
    };

    setMovimentoComplementos = () => {
        const antes = JSON.stringify(this.props.movimento.complementos);
        const comp = this.complementos
            .filter(complemento => complemento.valorSetado)
            .map(complemento => ComplementoGEDTO.novo(complemento));
        this.props.movimento.complementos = comp;
        const depois = JSON.stringify(this.props.movimento.complementos);
        if (antes !== depois) {
            MovimentoCNJStore.sameState = false;
        }
    };

    get openModal() {
        return (MovimentoCNJStore.codMovimentoModalOpen === this.props.movimento.codMovimentoCnj)
            && (MovimentoCNJStore.idProcessoModalOpen === this.props.processo.identificadorProcesso)
            && (MovimentoCNJStore.idMovimento === this.props.movimento.id)
            && MovimentoCNJStore.modalComplementosOpen
    }

    render() {
        return (
            <>
                {this.props.apenasBotoes ?
                    <BotaoComplementoMovimento movimento={this.props.movimento} emLote={this.props.emLote} processo={this.props.processo} />
                    :
                    (!this.props.emLote &&
                        <Modal
                            key={'Complementos-do-movimento-' + this.props.movimento.codMovimentoCnj + '-' + this.props.processo.numeroProcesso}
                            aberto={this.openModal}
                            fecharModal={this.fecharModal}
                            titulo={'Complementos do movimento ' + this.props.movimento.codMovimentoCnj + ' do processo ' + this.props.processo.numeroProcesso}
                            funcaoAcaoSecundaria={this.fecharModal}
                            labelAcaoSecundaria='Cancelar'
                            labelAcaoPrimaria={'Confirmar'}
                            funcaoAcaoPrimaria={this.handleClickConfirmar}
                            maxWidth='md'
                            fullWidth
                            disableRestoreFocus
                        >
                            <Typography>
                                {this.props.movimento.descricaoMovimento}
                            </Typography>
                            {this.props.movimento.complementosPossiveis?.map((complemento, index) => {
                                if (complemento.tipoComplemento === TipoComplemento_DOMINIO || complemento.tipoComplemento === TipoComplemento_DINAMICO) {
                                    return <ComplementoAutocomplete key={'complemento-' + index}
                                        processo={this.props.processo}
                                        movimento={this.props.movimento}
                                        complemento={complemento}
                                        listaDeComplementos={this.complementos}
                                        handleCallbackAutoComplete={this.handleCallbackAutoComplete}
                                    />
                                } else {
                                    return <ComplementoTextField key={'complemento-' + index}
                                        complemento={complemento}
                                        movimento={this.props.movimento}
                                        callbackAtualizarComplementos={this.setComplementos}
                                        complementos={this.complementos}
                                    />
                                }
                            })}
                        </Modal>
                    )
                }
            </>
        );
    }
}

export default observer(ModalComplementoMovimento);
